/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-11-25 14:04:15
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/FormItem/FormItem.tsx
 */
import React, { ReactNode } from 'react';
import css from './FormItem.less';
import { Form } from 'antd';
import { EnumFormItemStatus } from 'src/types/common/validation';
interface IProps {
  children;
  label?: string | ReactNode;
  name?;
  required?;
  status?: EnumFormItemStatus;
  help?: string | ReactNode;
  rules?;
  className?: string;
  labelCol?;
}
const FormItem = (props: IProps) => {
  const {
    className,
    children,
    label,
    name,
    required,
    status,
    help,
    rules,
    labelCol,
  } = props;

  return (
    <Form.Item
      label={label}
      name={name}
      required={required}
      validateStatus={status}
      help={help}
      labelCol={labelCol}
      rules={rules}
      className={`${css.formItem} ${className || ''}`}>
      {children}
    </Form.Item>
  );
};
export default FormItem;
